import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaSingleImageImageModel extends BaseModel {
  variables?: { [key: string]: string } | MetaSingleImageImageVariables;
}

export interface MetaSingleImageImageVariables {
  Image: string;
}

export class MetaSingleImageImageInitVariables implements MetaSingleImageImageVariables {
  Image = '';
}

export class MetaSingleImageImageInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaSingleImageImageInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}